import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { useUserProfile } from './useUserProfile';

export type MyPermissions = Record<string, boolean>;

export const MY_PERMISSIONS_QUERY_KEY = 'myPermissions';

export const useMyPermissions = () => {
  const { userData } = useUserProfile();
  return useQuery<MyPermissions>({
    queryKey: [MY_PERMISSIONS_QUERY_KEY, userData?.companyId, userData?.id],
    queryFn: async () => {
      const { data } = await api.get<MyPermissions>(
        '/v3/companies/my-permissions'
      );
      return data;
    },
    enabled: !!userData,
    staleTime: 1000 * 60 * 5
  });
};
